export default __webpack_public_path__ + "static/media/undraw_Analytics.06debedf.svg";